export const CCPA_ANALYTICS = "il_squeeze_upside_analytics";
export const CCPA_MARKETING = "il_squeeze_upside_marketing";
export const CCPA_PERSONALIZATION = "il_squeeze_upside_personalization";
